import React, {PureComponent} from 'react';
import {NotificationManager} from 'react-notifications';

import * as api from '../../lib/api';
import * as validation from '../../lib/validation';
import {withUser} from '../../lib/user';
import SideModal from '../../components/SideModal';
import Form from '../../components/Form';
import Input from '../../components/Input';
import ChipInput from '../../components/ChipInput';
import Button from '../../components/Button';
import {T} from '../../components/I18n'


class GroupFormModal extends PureComponent {
  state = this.getInitialState();

  getInitialState() {
    return {
      saving: false,
      validationEnabled: false,
      id: undefined,
      ...(this.props.group || createGroup())
    };
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.group !== this.props.group) {
      this.setState(this.getInitialState());
    }
  }

  handleChangeMembers = members => {
    this.setState({members});
  }

  handleSave = async () => {
    const {...group} = this.state;
    const {credentials, onSave} = this.props;
    
    if (hasValidations(getValidationErrors(group))) {
      this.setState({validationEnabled: true});
      return;
    }

    this.setState({saving: true});

    try {
      let response;

      if (group.id) {
        response = await api.updateUserGroup(group, credentials);
      }
      else {
        response = await api.createUserGroup(group, credentials);
      }

      NotificationManager.success(<T isolate><T variable="groupName">{response.name}</T> was saved</T>);
      onSave(response);
    }
    catch(e) {
      NotificationManager.error('Unable to save user group. Please try again');
    }
    finally {
      this.setState({saving: false});
    }
  }

  render() {
    const {open, users, onClose} = this.props;
    const {saving, validationEnabled, ...group} = this.state;
    const validations = getValidationErrors(group, {
      disabled: !validationEnabled
    });
    const invalid = hasValidations(validations);

    return (
      <Form onSubmit={this.handleSave}>
        <SideModal
          open={open}
          title={group.id ? 'Edit Group' : 'Create Group'}
          onClose={onClose}
          options={[
            <Button type="submit" disabled={saving || invalid}>{saving ? 'Saving...' : 'Save Group'}</Button>,
            <Button secondary onClick={onClose}>Cancel</Button>
          ]}>
          <SideModal.Content>
            <Form.Group>
              <Input
                id="group-title"
                label="Group Name"
                value={group.name}
                onChange={e => this.setState({name: e.target.value})}
                invalid={validations.name}
                validationText={validations.name}
              />
            </Form.Group>
            <Form.Group>
              <ChipInput
                id="group-members"
                label="Members"
                value={group.members.map(user => ({...user, toString: () => user.userName}))}
                suggestions={users.map(user => ({...user, toString: () => user.userName}))}
                onChange={this.handleChangeMembers}
              />
            </Form.Group>
          </SideModal.Content>
        </SideModal>
      </Form>
    );
  }
}

const isValuePresent = validation.create((value, {isEmpty, trim}) => !isEmpty(trim(value)));

function getValidationErrors(group, options = {disabled: false}) {
  if (options.disabled) {
    return {};
  }
  
  return {
    name: isValuePresent(group.name) ? null : 'A group name is required'
  };
}

function hasValidations(validations) {
  return Object.keys(validations).map(key => validations[key]).filter(Boolean).length > 0;
}

function createGroup() {
  return {
    name: '',
    members: []
  };
}

export default withUser(GroupFormModal);